import { Badge } from '@/components/ui/badge';
import type { DocumentStatus } from '@rock/types';
import { assertUnreachable } from '@rock/util';
import type { FC } from 'react';

export const DocumentStatusBadge: FC<{ status: DocumentStatus | undefined }> = ({ status }) => {
    if (!status) {
        return <span className="text-muted-foreground">-</span>;
    }

    switch (status) {
        case 'approved':
            return <Badge className="bg-green-600">approved</Badge>;
        case 'draft':
            return (
                <Badge variant="outline" className="text-blue-700 border-blue-700 bg-background">
                    draft
                </Badge>
            );
        case 'revisit':
            return <Badge className="bg-yellow-600">revisit</Badge>;
        case 'retired':
            // The Notion page is gone (deleted, or moved out of its database). Withheld from the
            // catalog like a draft, but not something anyone can edit back into life.
            return (
                <Badge variant="outline" className="text-muted-foreground border-muted-foreground bg-background">
                    retired
                </Badge>
            );
        default:
            assertUnreachable(status);
    }
};
